module.exports = __webpack_public_path__ + "static/media/gates-renewable.ede2717d.png";